<template>
  <div>
    <v-card>
      <v-card-title>
        Top Jobs for {{ userProfile.unitGroup }}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <div style="width: 1em;"></div>
        <v-btn rounded dark color="#00AEEF" @click="resetSearch" pl-5>Reset</v-btn>
      </v-card-title>
      <v-data-table
        multi-sort
        :headers="headers"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50],
        }"
        :items="topList"
        :search="search"
      >
        <template #body.prepend>
          <tr>
            <td></td>
            <td class="text-start"></td>
            <td class="text-start user-profile">{{ userProfile.unitGroup }}</td>
            <td class="text-center">
              <v-btn
                class="mx-2"
                fab
                dark
                depressed
                color="light-blue darken-1"
              >{{ Math.round(userProfile.blue) }}%</v-btn>
            </td>
            <td class="text-center">
              <v-btn
                class="mx-2"
                fab
                dark
                depressed
                color="#00ad48"
              >{{ Math.round(userProfile.green) }}%</v-btn>
            </td>
            <td class="text-center">
              <v-btn
                class="mx-2"
                fab
                dark
                depressed
                color="#D50000"
              >{{ Math.round(userProfile.red) }}%</v-btn>
            </td>
            <td class="text-center">
              <v-btn
                class="mx-2"
                fab
                depressed
                :ripple="false"
                color="#FDD835"
              >{{ Math.round(userProfile.yellow) }}%</v-btn>
            </td>
            <td class="text-start"></td>
            <td>
              <DataTableBarChart :profile="userProfile" width="100%" height="50" valign="middle" />
            </td>
          </tr>
        </template>
        <template #item="{ item }">
          <tr>
            <td class="text-center">
              <v-icon @click="deleteItem(item)">mdi-close</v-icon>
            </td>
            <td
              class="text-start"
              @click="onClick(item)"
              :style="{ cursor: 'pointer' }"
            >{{ item.noc }}</td>
            <td
              class="text-start"
              @click="onClick(item)"
              :style="{ cursor: 'pointer' }"
            >{{ truncatedUnitGroup(item.unitGroup) }}</td>
            <td class="text-center blue-cell" @click="onClick(item)" :style="{ cursor: 'pointer' }">
              <!-- <span>{{ item.blue }}%</span> -->
              <v-btn class="mx-2" fab dark depressed small color="#40c4ff">{{ item.blue }}%</v-btn>
            </td>
            <td
              class="text-center green-cell"
              @click="onClick(item)"
              :style="{ cursor: 'pointer' }"
            >
              <!-- <span>{{ item.green }}%</span> -->
              <v-btn class="mx-2" fab dark depressed small color="#00c853">{{ item.green }}%</v-btn>
            </td>
            <td class="text-center red-cell" @click="onClick(item)" :style="{ cursor: 'pointer' }">
              <!-- <span>{{ item.red }}%</span> -->
              <v-btn class="mx-2" fab small dark depressed color="red">{{ item.red }}%</v-btn>
            </td>
            <td
              class="text-center yellow-cell"
              @click="onClick(item)"
              :style="{ cursor: 'pointer' }"
            >
              <!-- <span>{{ item.yellow }}%</span> -->
              <v-btn class="mx-2" fab small depressed color="#ffeb3b">{{ item.yellow }}%</v-btn>
            </td>
            <td class="text-center" @click="onClick(item)" :style="{ cursor: 'pointer' }">
              {{ item.similarity }}%
            </td>
            <td @click="onClick(item)" :style="{ cursor: 'pointer' }">
              <DataTableBarChart :profile="item" width="100%" height="50" valign="middle" />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog" max-width="600">
      <DetailsPanel :profile="details " @closeModal="dialog = false" />
    </v-dialog>
  </div>
</template>

<script>
import DataTableBarChart from "./DataTableBarChart";
import DetailsPanel from "./DetailsPanel";

export default {
  data() {
    return {
      props: {
        data: Array,
        userProfile: Object,
      },
      search: "",
      headers: [
        { text: "", value: "actions", sortable: false, width: 20 },

        {
          text: "NOC",
          align: "start",
          sortable: true,
          value: "noc",
          width: 70,
        },
        { text: "Unit Group", value: "unitGroup", sortable: true, width: 350 },
        { text: "Blue", value: "blue", filterable: false, width: 20 },
        { text: "Green", value: "green", filterable: false, width: 20 },
        { text: "Red", value: "red", filterable: false, width: 20 },
        { text: "Yellow", value: "yellow", filterable: false, width: 20 },
        {
          text: "Similarity",
          value: "similarity",
          filterable: false,
          sortable: true,
          width: 90,
        },
        {
          text: "Graph",
          value: "graph",
          filterable: false,
          width: 200,
          sortable: false,
        },
      ],
      placeholder: "This User",
      dialog: false,
      details: null,
    };
  },
  methods: {
    truncatedUnitGroup: function (unitGroup) {
      return unitGroup.length > 50 ? unitGroup.slice(0, 50) + "..." : unitGroup;
    },
    resetSearch: function () {
      this.search = "";
    },
    calculateSimilarity: function (profile1, profile2) {
      let blueDiff = Math.abs(+profile1.blue - +profile2.blue);
      let greenDiff = Math.abs(+profile1.green - +profile2.green);
      let redDiff = Math.abs(+profile1.red - +profile2.red);
      let yellowDiff = Math.abs(+profile1.yellow - +profile2.yellow);

      let temp =
        100 -
        Math.round(
          Math.sqrt(
            Math.pow(+blueDiff, 2) +
              Math.pow(+greenDiff, 2) +
              Math.pow(+redDiff, 2) +
              Math.pow(+yellowDiff, 2)
          ) / Math.sqrt(2)
        );
      return temp;
    },
    onClick(profile) {
      this.details = profile;
      this.dialog = true;
    },
    deleteItem(item) {
      const index = item.noc;
      this.$store.dispatch("addExclusion", index);
    },
  },
  computed: {
    userProfile: function () {
      return this.$store.getters.getUserProfile;
    },
    topList() {
      return this.$store.getters
        .getTopList(this.userProfile, 500, 1)
        .map((x) => {
          return {
            ...x,
            similarity: this.calculateSimilarity(x, this.userProfile),
          };
        });
    },
  },
  components: {
    DataTableBarChart,
    DetailsPanel,
  },
};
</script>

<style scoped>
tr {
  justify-content: center;
}
td {
  padding: 0;
}
th {
  padding: 0 !important;
}
.user-profile {
  font-weight: 700;
  font-size: 1.3em;
}

.blue-cell span {
  background-color: #40c4ff;
  color: #eee;
  padding: 12px;
  border-radius: 5px;
  font-size: 1.2em;
  width: 80%;
}
.green-cell span {
  background-color: #00c853;
  color: #eee;
  padding: 12px;
  border-radius: 5px;
  font-size: 1.2em;
}

.red-cell span {
  background-color: #ff5252;
  color: #333;
  padding: 12px;
  border-radius: 5px;
  font-size: 1.2em;
}
.yellow-cell span {
  background-color: #ffeb3b;
  color: #333;
  padding: 12px;
  border-radius: 5px;
  font-size: 1.2em;
  width: 100%;
}
.v-icon:hover {
  color: red;
}
</style>
